export const aiAnalysisRoutes = {
	setup: '/ai-analysis/setup',
};
